export const getCenterCoordinates = () => {
  const center: any = {
    lat: 38.46706025,
    lng: 140.8796083
  }
  return center
}
export const getDefaultZoomLevel = () => {
  const zoom: number = 14
  return zoom
}
